import React from 'react';
import './ExerciseHeader.css';

const ExerciseHeader = ({ part_label, question_count_label, instruction, story_text }) => {
  return (
    <div className="exercise-header transition-all duration-300 ease-in-out">
      <div className="part-info">
        <h2 className="part-label">{part_label}</h2>
        {question_count_label && <p className="question-count-label">{question_count_label}</p>}
        {story_text && <p className="story-text">{story_text}</p>}
        <p className="instruction-text">{instruction}</p>
      </div>
    </div>
  );
};

export default ExerciseHeader;